// fomo-badges

const FLAME_ICON_SVG =
  '<svg class="icon-flame" width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.6303 1.28579C10.5086 1.12249 10.3256 1.01575 10.1235 0.990103C9.92145 0.964455 9.71764 1.02211 9.55893 1.14981C7.68875 2.65463 6.38439 4.83776 6.02021 7.32637C5.36364 6.85041 4.78699 6.27052 4.31459 5.61081C4.18463 5.42933 3.98059 5.31516 3.75794 5.29934C3.53529 5.28353 3.31716 5.36771 3.16286 5.529C1.61746 7.14442 0.666992 9.33683 0.666992 11.7497C0.666992 16.7202 4.69643 20.7497 9.66699 20.7497C14.6376 20.7497 18.667 16.7202 18.667 11.7497C18.667 8.08876 16.4813 4.93999 13.3468 3.53406C12.2376 2.99256 11.3217 2.21284 10.6303 1.28579ZM13.417 13.25C13.417 15.3211 11.7381 17 9.66699 17C7.59592 17 5.91699 15.3211 5.91699 13.25C5.91699 12.8407 5.98258 12.4467 6.10381 12.0779C6.73228 12.5425 7.45469 12.8874 8.2373 13.0787C8.45319 11.6779 9.15356 10.437 10.1619 9.53241C11.999 9.77462 13.417 11.3467 13.417 13.25Z"/></svg>'

const LIGHTNING_ICON_SVG =
  '<svg class="icon-lightning" width="100%" height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><path d="M3.405,37.303c-0,-1.255 1.016,-2.273 2.27,-2.273l12.483,-0c1.254,-0 2.27,1.018 2.27,2.273c0,1.255 -1.016,2.273 -2.27,2.273l-12.483,0c-1.254,0 -2.27,-1.018 -2.27,-2.273Zm-3.405,-12.503c-0,-1.255 1.016,-2.273 2.27,-2.273l10.214,0c1.254,0 2.27,1.018 2.27,2.273c-0,1.256 -1.016,2.274 -2.27,2.274l-10.214,-0c-1.254,-0 -2.27,-1.018 -2.27,-2.274Zm4.54,-12.502c-0,-1.255 1.016,-2.273 2.269,-2.273l11.349,-0c1.254,-0 2.27,1.018 2.27,2.273c0,1.256 -1.016,2.273 -2.27,2.273l-11.349,0c-1.253,0 -2.269,-1.017 -2.269,-2.273Zm33.044,-12.139c0.97,0.384 1.554,1.38 1.416,2.415l-2.36,16.544l8.632,-0l0.079,-0c0.501,-0 1.02,-0.001 1.449,0.039c0.422,0.038 1.19,0.141 1.876,0.671c0.8,0.619 1.285,1.561 1.322,2.573c0.032,0.868 -0.331,1.553 -0.545,1.919c-0.217,0.372 -0.519,0.795 -0.81,1.204l-0.046,0.064l-15.597,23.46c-0.606,0.849 -1.712,1.176 -2.681,0.793c-0.97,-0.384 -1.554,-1.38 -1.416,-2.415l2.552,-16.943l-8.633,0l-0.078,0.001c-0.501,-0 -1.021,-0 -1.45,-0.04c-0.422,-0.038 -1.189,-0.141 -1.876,-0.671c-0.8,-0.619 -1.284,-1.561 -1.322,-2.573c-0.032,-0.867 0.331,-1.553 0.545,-1.919c0.217,-0.372 0.519,-0.795 0.811,-1.204l0.045,-0.063l15.406,-23.062c0.606,-0.849 1.712,-1.176 2.681,-0.793Z"/></svg>'

const WARNING_ICON_SVG =
  '<svg class="icon-warning" width="100%" height="100%" viewBox="0 0 55 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><path d="M23.289,2.484c1.872,-3.312 6.55,-3.312 8.422,0l22.631,40.063c1.87,3.312 -0.468,7.453 -4.211,7.453l-45.262,0c-3.743,0 -6.082,-4.141 -4.21,-7.453l22.63,-40.063Zm4.21,33.672c-1.838,-0 -3.328,1.64 -3.328,3.661c0,2.023 1.49,3.661 3.328,3.661c1.839,0 3.329,-1.638 3.329,-3.661c-0,-2.023 -1.49,-3.661 -3.329,-3.661Zm-2.576,-22.491c-1.008,-0 -1.784,0.957 -1.666,2.058l1.618,15.345c0.098,0.934 0.81,1.633 1.667,1.633l1.96,-0c0.857,-0 1.571,-0.701 1.667,-1.639l1.574,-15.345c0.113,-1.101 -0.661,-2.052 -1.667,-2.052l-5.153,-0Z" style="fill-rule:nonzero;"/></svg>'

const TROPHY_ICON_SVG =
  '<svg class="icon-trophy" width="100%" height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><path d="M14.646,0.001l-0.204,-0c-0.711,-0.003 -1.588,-0.007 -2.36,0.274c-1.263,0.46 -2.257,1.454 -2.717,2.717c-0.182,0.499 -0.244,1.041 -0.265,1.554l-3.478,0c-0.478,0 -0.943,0 -1.338,0.027c-0.433,0.03 -0.946,0.099 -1.478,0.319c-1.114,0.462 -1.998,1.347 -2.46,2.46c-0.22,0.532 -0.289,1.045 -0.319,1.478c-0.027,0.396 -0.027,0.861 -0.027,1.338l0,1.509c-0.001,1.808 -0.002,3.15 0.31,4.313c0.841,3.137 3.291,5.588 6.428,6.428c0.865,0.232 1.829,0.291 3.01,0.306c1.746,5.87 6.787,10.32 12.979,11.206l0,2.434l-1.01,-0c-5.718,-0 -10.353,4.635 -10.353,10.353c-0,1.813 1.469,3.283 3.282,3.283l20.707,0c1.814,0 3.283,-1.47 3.283,-3.283c0,-5.718 -4.635,-10.353 -10.353,-10.353l-1.01,-0l-0,-2.434c6.192,-0.885 11.233,-5.336 12.979,-11.206c1.181,-0.015 2.145,-0.074 3.01,-0.306c3.137,-0.84 5.587,-3.291 6.428,-6.428c0.312,-1.163 0.311,-2.505 0.31,-4.313l-0,-1.509c-0,-0.477 -0,-0.942 -0.027,-1.338c-0.03,-0.433 -0.099,-0.946 -0.319,-1.478c-0.462,-1.113 -1.346,-1.998 -2.46,-2.46c-0.532,-0.22 -1.045,-0.289 -1.478,-0.319c-0.395,-0.027 -0.86,-0.027 -1.338,-0.027l-3.478,0c-0.021,-0.513 -0.083,-1.055 -0.265,-1.554c-0.46,-1.263 -1.454,-2.257 -2.717,-2.717c-0.772,-0.281 -1.649,-0.277 -2.36,-0.274l-0.205,0l-20.707,0Zm-5.555,10.909c-0,-0.636 -0,-0.955 -0.124,-1.198c-0.109,-0.214 -0.283,-0.387 -0.497,-0.496c-0.243,-0.124 -0.561,-0.124 -1.197,-0.124l-1.038,-0c-0.6,-0 -0.9,-0 -1.137,0.116c-0.205,0.1 -0.382,0.268 -0.493,0.468c-0.128,0.23 -0.143,0.52 -0.173,1.102c-0.072,1.37 -0.065,2.792 0.269,4.036c0.42,1.568 1.645,2.793 3.214,3.214c0.27,0.072 0.591,0.111 1.176,0.132l-0,-7.25Zm31.818,0.007c-0,-0.638 -0,-0.958 0.125,-1.201c0.109,-0.215 0.284,-0.389 0.498,-0.497c0.245,-0.124 0.564,-0.122 1.203,-0.12l1.018,0.004c0.598,0.003 0.897,0.004 1.133,0.12c0.204,0.101 0.379,0.268 0.49,0.467c0.128,0.23 0.143,0.52 0.174,1.099c0.073,1.372 0.072,2.822 -0.251,4.025c-0.42,1.568 -1.645,2.793 -3.214,3.214c-0.27,0.072 -0.591,0.111 -1.176,0.132l-0,-7.243Z"/></svg>'

setTimeout(() => initFomoBadge(), 1500)

async function initFomoBadge() {
  const productInfo = document.querySelector('product-info')
  if (!productInfo) return

  const productId = productInfo.dataset.productId
  const singVariantsList = productInfo.querySelector('.liquid-pdp__product-color-swatches-wrapper')
  const packVariantsList = productInfo.querySelector('.liquid-pdp__product-colors-buttons')
  const inputSelector = `input[data-product-id="${productId}"]`

  const isBestSeller =
    packVariantsList?.firstElementChild?.querySelector(inputSelector) ||
    singVariantsList?.firstElementChild?.querySelector(inputSelector)
      ? true
      : false

  const isLowStock = productInfo.dataset.lowStock === 'true'

  if (!isBestSeller && !isLowStock) return

  const gallery = document.querySelector('.liquid-pdp__gallery-main')
  if (!gallery) return

  // Ensure gallery can contain absolutely positioned children
  const galleryComputedStyle = window.getComputedStyle(gallery)
  if (galleryComputedStyle.position === 'static') gallery.style.position = 'relative'

  const trendingText = 'Trending!'
  const sellingFastText = 'Selling Fast!'
  const bestSellerText = '🔥 Top Seller!'
  const lowStockText = 'Low Inventory!'

  let iconSVG = ''
  let labelText = ''
  let metricText = ''

  if (isLowStock) {
    iconSVG = WARNING_ICON_SVG
    labelText = lowStockText
  } else if (isBestSeller) {
    labelText = bestSellerText
  }
  // Disable metric text
  metricText = ''

  const badge = document.createElement('div')
  badge.classList.add('fomo-badge')
  let icon = null
  if (isLowStock) {
    icon = document.createElement('span')
    icon.classList.add('fomo-badge__icon')
    icon.innerHTML = iconSVG
  }
  const label = document.createElement('span')
  label.classList.add('fomo-badge__label')
  const metric = document.createElement('span')
  metric.classList.add('fomo-badge__metric')
  if (isLowStock) badge.appendChild(icon)
  badge.appendChild(label)
  if (metricText) badge.appendChild(metric)
  label.textContent = labelText
  metric.textContent = metricText

  showAndHideBadge(gallery, badge)
}

async function hideFomoBadge() {
  const gallery = document.querySelector('.liquid-pdp__gallery-main')
  if (!gallery) return

  const badge = gallery.querySelector('.fomo-badge')
  if (badge) {
    badge.style.opacity = '0'
    setTimeout(() => badge.remove(), 500)
  }
}
window.hideFomoBadge = hideFomoBadge

let hasShownBadgeOnScroll = false

function setupFomoBadgeScrollListener() {
  const gallery = document.querySelector('.liquid-pdp__gallery-main')
  if (!gallery) return

  let scrolledPast = false
  let timerId = null

  function checkPositionAndShowBadge() {
    if (!!document.querySelector('.fomo-badge')) return // don't show 2 badges at once

    const { top, bottom } = gallery.getBoundingClientRect()

    // mark when user has scrolled the gallery out of view (above viewport)
    if (!scrolledPast && bottom < 0) scrolledPast = true
    if (!scrolledPast) return

    const fullyVisible = top >= 0 && bottom <= window.innerHeight

    if (fullyVisible) {
      if (!timerId) {
        timerId = setTimeout(() => {
          // re-check visibility after delay
          const { top: t2, bottom: b2 } = gallery.getBoundingClientRect()
          if (t2 >= 0 && b2 <= window.innerHeight && hasShownBadgeOnScroll === false) {
            initFomoBadge()
            hasShownBadgeOnScroll = true
          }
        }, 500)
      }
    } else if (timerId) {
      clearTimeout(timerId)
      timerId = null
    }
  }

  window.addEventListener('scroll', checkPositionAndShowBadge, { passive: true })
}
document.addEventListener('DOMContentLoaded', setupFomoBadgeScrollListener)

function showLowStockBadge({ checkFirst = false } = {}) {
  setTimeout(() => {
    if (!!document.querySelector('.fomo-badge')) return // don't show 2 badges at once

    if (checkFirst) {
      const productInfo = document.querySelector('product-info')
      const isLowStock = productInfo?.dataset.lowStockVariant === 'true'
      if (!isLowStock) return
    }

    const gallery = document.querySelector('.liquid-pdp__gallery-main')
    if (!gallery) return

    // Ensure gallery can contain absolutely positioned children
    const galleryComputedStyle = window.getComputedStyle(gallery)
    if (galleryComputedStyle.position === 'static') gallery.style.position = 'relative'

    // Disable metric text
    const showMetric = false

    const lowStockText = 'Low Inventory!'

    const badge = document.createElement('div')
    badge.classList.add('fomo-badge')
    const icon = document.createElement('span')
    icon.classList.add('fomo-badge__icon')
    icon.innerHTML = WARNING_ICON_SVG
    const label = document.createElement('span')
    label.classList.add('fomo-badge__label')
    badge.appendChild(icon)
    badge.appendChild(label)
    label.textContent = lowStockText
    if (showMetric) {
      const metric = document.createElement('span')
      metric.classList.add('fomo-badge__metric')
      badge.appendChild(metric)
      // metric text disabled
    }

    showAndHideBadge(gallery, badge)
  }, 1000)
}
window.showLowStockBadge = showLowStockBadge

function showAndHideBadge(gallery, badge) {
  gallery.appendChild(badge)
  // trigger fade-in after next paint
  requestAnimationFrame(() => badge.classList.add('visible'))

  setTimeout(() => {
    badge.style.opacity = 0
    setTimeout(() => badge.remove(), 500)
  }, 6000)
}

function formatBigNumber(num) {
  const str = typeof num === 'string' ? num : num.toString()
  // prettier-ignore
  switch (str.length) {
    case 1 || 2 || 3: return str
    case 4:  return `${str.substr(0,1)},${str.substr(1,3)}`
    case 5:  return `${str.substr(0,2)},${str.substr(2,3)}`
    case 6:  return `${str.substr(0,3)},${str.substr(3,3)}`
    case 7:  return `${str.substr(0,1)},${str.substr(1,3)},${str.substr(4,3)}`
    default: return str
  }
}
